export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
};

export const dashboardConfig = {
    mainDashboard: 'splus_privilege_line',
    activityDashboard: 'splus_line_activity',
    flashsale: 'splus_flashsale'
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
};

export const historyConfig = {
    purchase: 'purchase',
    reward: 'MyRewardsPurchase'//'MyRewardsPurchase'
};
